var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewyearClips24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8763 7.44763C21.9145 8.29585 21.2343 9 20.3852 9H3.61473C2.76566 9 2.08552 8.29583 2.12365 7.44762C2.14813 6.90291 2.17445 6.37171 2.20083 5.87122C2.30503 3.89458 3.86622 2.31779 5.84219 2.20158C7.59671 2.09841 9.70722 2 11.375 2C13.2131 2 15.9328 2.11954 18.1041 2.23326C20.1032 2.33795 21.6969 3.9234 21.8018 5.92244C21.8273 6.4079 21.8527 6.92146 21.8763 7.44763Z",
    fill: "url(#paint0_linear_2_74)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7208 4.00473C10.0042 4.01457 9.54561 4.76302 9.84848 5.41252L10.5526 6.92262C10.7169 7.27484 11.0703 7.5 11.459 7.5H13.0106C13.7421 7.5 14.2261 6.74034 13.9169 6.07738L13.2207 4.58419C13.0602 4.24011 12.7187 4.01594 12.3392 4.00928C11.9971 4.00328 11.6735 4 11.375 4C11.1642 4 10.9456 4.00164 10.7208 4.00473ZM4.17337 6.45502C4.14463 7.02428 4.59952 7.5 5.1695 7.5H7.04544C7.77693 7.5 8.26089 6.74034 7.95175 6.07738L7.33225 4.74885C7.16 4.37947 6.78079 4.15131 6.37387 4.17427C6.2341 4.18215 6.09589 4.19012 5.95961 4.19813C5.00457 4.2543 4.24887 5.01282 4.19807 5.97651C4.1898 6.13339 4.18155 6.29307 4.17337 6.45502ZM16.8425 4.17221C16.094 4.13605 15.5787 4.90857 15.8954 5.58775L16.5178 6.92262C16.6821 7.27484 17.0355 7.5 17.4241 7.5H18.8305C19.4005 7.5 19.8554 7.02428 19.8266 6.45502C19.8193 6.31051 19.812 6.1678 19.8046 6.02726C19.7536 5.05592 18.9819 4.28197 17.9996 4.23052C17.6263 4.21097 17.2382 4.19133 16.8425 4.17221Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4906 9C21.2986 9 21.963 9.6399 21.981 10.4476C21.9931 10.9889 22 11.5122 22 12C22 13.8351 21.9018 16.1726 21.8019 18.0776C21.6969 20.0766 20.1032 21.662 18.1042 21.7667C15.9328 21.8805 13.2131 22 11.375 22C9.70723 22 7.59672 21.9016 5.8422 21.7984C3.86623 21.6822 2.30504 20.1054 2.20084 18.1288C2.09994 16.2147 2 13.8515 2 12C2 11.5122 2.00694 10.9889 2.019 10.4476C2.037 9.6399 2.70145 9 3.50938 9H20.4906ZM14.8982 13.5097C15.4339 13.8963 15.4339 14.7037 14.8982 15.0903L14.7887 15.1694C13.5628 16.054 12.2573 16.8191 10.8897 17.4544L10.7675 17.5112C10.1698 17.7888 9.48095 17.3851 9.41899 16.7209L9.40632 16.5851C9.26454 15.0651 9.26454 13.5349 9.40632 12.0149L9.41899 11.8791C9.48095 11.2149 10.1698 10.8112 10.7675 11.0888L10.8897 11.1456C12.2573 11.7809 13.5628 12.546 14.7887 13.4306L14.8982 13.5097Z",
    fill: "url(#paint1_linear_2_74)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8982 13.5097C15.4339 13.8963 15.4339 14.7037 14.8982 15.0903L14.7887 15.1694C13.5628 16.054 12.2573 16.8191 10.8897 17.4544L10.7675 17.5112C10.1698 17.7888 9.48095 17.3851 9.41899 16.7209L9.40632 16.5851C9.26454 15.0651 9.26454 13.5349 9.40632 12.0149L9.41899 11.8791C9.48095 11.2149 10.1698 10.8112 10.7675 11.0888L10.8897 11.1456C12.2573 11.7809 13.5628 12.546 14.7887 13.4306L14.8982 13.5097Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_74",
    x1: 2.06113,
    y1: 2,
    x2: 6.44733,
    y2: 14.4554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_74",
    x1: 2,
    y1: 9,
    x2: 13.8805,
    y2: 27.2777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66CC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56BF8B"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewyearClips24);
export default __webpack_public_path__ + "static/media/newyear-clips_24.83b09d4b.svg";
export { ForwardRef as ReactComponent };